import * as Factory from 'factory.ts'
import faker from 'faker'

import { UserMock } from './user.factory'
import { type InboxMessage } from '../../models'

export const InboxMessageMock = Factory.Sync.makeFactory<InboxMessage>({
  comment: Factory.each(() => faker.lorem.paragraph()),
  content_type: 1,
  id: Factory.each(() => faker.random.number()),
  is_ping: false,
  object_pk: Factory.each(() => faker.random.number().toString()),
  object_number: Factory.each(() => faker.random.number().toString()),
  permalink: Factory.each(() => faker.internet.url()),
  ping_user: null,
  submit_date: Factory.each(() => faker.date.past(0.2).toISOString()),
  userprofile: Factory.each(() => UserMock.build()),
  user_url: '',
  user: null,
}).withDerivation1(['userprofile'], 'user', (userprofile) => userprofile.id)
